import axios from "axios";
import {
  PAYMENT_LOAD_ATTEMPT,
  PAYMENT_LOAD_SUCCESS,
  PAYMENT_LOAD_FAILED,
  ///////////////////////
  PAYMENT_SAVE_ATTEMPT,
  PAYMENT_SAVE_SUCCESS,
  PAYMENT_SAVE_FAILED,
} from "../types/paymentTypes";
import { config } from "../../config";

const url_api = config.api.godiway;

export function loading() {
  return { type: PAYMENT_LOAD_ATTEMPT };
}

export function success(data) {
  return { type: PAYMENT_LOAD_SUCCESS, data };
}

export function failed(error) {
  return { type: PAYMENT_LOAD_FAILED, error };
}

export function saving() {
  return { type: PAYMENT_SAVE_ATTEMPT };
}

export function saveSuccess(data) {
  return { type: PAYMENT_SAVE_SUCCESS, data };
}

export function saveFailed(error) {
  return { type: PAYMENT_SAVE_FAILED, error };
}

export const loadItem = (data: Object) => async (dispatch) => {
  dispatch(loading());
  try {
    const response = await axios.get(url_api + "payment", {
      params: { id: data.user_id },
      headers: { Authorization: `Bearer ${data.token}` },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(success(response.data.body));
      return { ok: true, data: response.data.body };
    }
    dispatch(failed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(failed("try_later"));
    return { ok: false, error: "try_later" };
  }
};

export const updateItem = (data: Object) => async (dispatch) => {
  dispatch(saving());
  try {
    const response = await axios.put(
      url_api + "payment",
      {
        id: data.user_id,
        transfer: data.transfer,
        gateway: data.gateway,
      },
      { headers: { Authorization: `Bearer ${data.token}` } }
    );

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(saveSuccess(response.data.body));
      return { ok: true, data: response.data.body };
    }
    dispatch(saveFailed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(saveFailed("try_later"));
    return { ok: false, error: "try_later" };
  }
};
